<template>
<div class="m-page">
    <!-- <Header custom-active="0"></Header> -->
    <userHeader custom-active="3"></userHeader>
    <div class="body">
        <div class="signup-box">
            <el-form ref="form" :model="form" :rules="rules" @validate="formValidate">
                <div class="inner">
                    <div class="hd">
                        <div class="title">{{ $t("lang.SignUp") }}</div>
                        <div class="description">
                            {{ $t("lang.Welcome") }}<br />
                            {{ $t("lang.Register") }}
                        </div>
                    </div>
                    <div class="bd">
                        <el-form-item class="form-item" :label="$t('lang.Referral')" >
                            <el-input v-model="form.inviteCode" :disabled="isInviteCode" :placeholder="$t('lang.referral')" />
                        </el-form-item>
                        <el-form-item class="form-item" :label="$t('lang.username')" prop="account">
                            <el-input v-model="form.account" :placeholder="$t('lang.usernamePlaceholder')" />
                        </el-form-item>
                        <el-form-item class="form-item" :label="$t('lang.email')" prop="email">
                            <el-input v-model="form.email" :placeholder="$t('lang.emailPlaceholder')" />
                            
                        </el-form-item>
                        <el-form-item class="form-item" :label="$t('lang.verifyCode')" prop="verifyCode">
                            <el-input v-model="form.verifyCode" :placeholder="$t('lang.verifyCodePlaceholder')">
                                <template slot="append">
                                    <el-button type="primary" :loading="btnLoading" :disabled="btnIsDisabled" @click="sendCode">{{ $t('lang.sendVerifyCode') }}</el-button>
                                </template>
                            </el-input>
                        </el-form-item>
                        <el-form-item class="form-item" :label="$t('lang.password')" prop="password">
                            <el-input v-model="form.password" show-password :placeholder="$t('lang.passwordPlaceholder')" />
                        </el-form-item>
                        <el-form-item class="form-item" :label="$t('lang.confirmPassword')" prop="checkPassword">
                            <el-input v-model="form.checkPassword" show-password :placeholder="$t('lang.confirmPasswordPlaceholder')" />
                        </el-form-item>
                        <!-- <el-form-item class="form-item">
                            <el-checkbox>I agree to the terms of service </el-checkbox>
                        </el-form-item> -->
                        <el-form-item class="form-item" style="padding-top:10px;">
                            <el-button type="primary" class="btn-login" @click="submit" :loading="submitBtnLoading">{{ $t('lang.createAccount') }}</el-button>
                        </el-form-item>
                    </div>
                    <div class="ft">
                        <div class="p">
                            {{ $t("lang.AlreadyAccount") }} <a class="link" @click="goto('/login')"> {{ $t("lang.Login") }}</a>
                        </div>
                    </div>
                </div>
            </el-form>
        </div>
    </div>
    <Footer></Footer>
</div>  
</template>
<script>
import Header from "@/components/mobile/header";
import userHeader from "@/components/mobile/userHeader";
import Footer from "@/components/mobile/footer";
import {BASE_GLOB_API} from "@/config.js";
import {axiosGet, axiosPost} from '@/api/api';
export default {
    name:'signup-m',
    components: {
        Header,
        Footer,
        userHeader
    },
    data(){
        var validatePass2 = (rule, value, callback) => {
            if (value === '') {
                callback(new Error('请再次输入密码'));
            } else if (value !== this.form.password) {
                callback(new Error('两次输入密码不一致!'));
            } else {
                callback();
            }
        };
        return {
            form:{
                account:'',
                email:'',
                verifyCode:'',
                password:'',
                checkPassword:'',
                inviteCode:'',
            },
            rules:{
                account:[{required:true, message:this.$t('lang.usernameRule')}],
                email:[{required:true, message:'Email is required'},{type:'email', message:'Incorrect email format'}],
                verifyCode:[{required:true, message:'Verify Code is required'}],
                password:[{required:true, message:'Password is required'}],
                checkPassword:[{required:true, message:'Confirm Password is required'}, {validator: validatePass2}],
            },
            url:{
                sendCode:BASE_GLOB_API+'/register/verifyCode/send',
                register:BASE_GLOB_API+'/register/email',
                tempId:BASE_GLOB_API+'/user/tempId',
            },
            formValid:{
                account:false,
                email:false,
                verifyCode:false,
                password:false,
                checkPassword:false,
            },
            isAgree:false,
            btnLoading:false,
            submitBtnLoading:false,
            returnUrl:'',
            lang: "",
            isInviteCode:false,
        }
    },
    computed:{
        btnIsDisabled:function(){
            let flag = false, email = this.form.email;
            if(email.length > 0 && /^\w+((-\w+)|(\.\w+))*\@[A-Za-z0-9]+((\.|-)[A-Za-z0-9]+)*\.[A-Za-z0-9]+$/.test(email)){
                flag = true;
            }
            return !flag;
        },
    },
    created(){
        this.lang = sessionStorage.getItem("Language")
    },
    mounted(){
        console.log("query",this.$route.query)
        // if(this.$route.query){
        //     this.returnUrl = this.$route.query.redirect;
        // }
        if( this.$route.query.inviteCode){
            this.form.inviteCode = this.$route.query.inviteCode;
            this.isInviteCode =true;
        }
    },
    methods:{
        goto(url){
            this.$router.push({path:url})
        },
        sendCode(){
            console.log("send code");
            let params = {
                email:this.form.email
            }
            this.btnLoading = true;
            axiosGet(this.url.sendCode, params,60000).then(res=>{
                console.log("=====",res)
                if(res.success){
                    this.$message.success(res.message);
                    this.btnLoading = false;
                }
                
            })
        },
        formValidate(e,r){
            // console.log("formValidate e :",e,r)
            this.formValid[e] = r;
        },
        submit(){
            let that = this;
            this.$refs.form.validate((valid)=>{
                if(valid){
                    let params = Object.assign({}, that.form);
                    that.submitBtnLoading = true;
                    axiosPost(that.url.register, params).then(res=>{
                        if(res.success){
                            that.settingAccount(res.result);
                            that.$message.success(res.message);
                            that.submitBtnLoading = false;
                        }else{
                            that.$message.error(res.message);
                            that.submitBtnLoading = false;
                        }
                    }).catch((err)=>{
                        that.$message.error(err);
                        that.submitBtnLoading = false;
                    })
                }
            })
        },
        settingAccount(data){
            window.sessionStorage.setItem("Token", data.token);
            window.localStorage.setItem("Token", data.token);
            window.sessionStorage.setItem('salt', data.salt);
            let userinfo = {
                id:data.id,
                account:data.account,
                nikeName:data.nikeName,
                avatar:data.headImg,
                email:data.email,
            }
            window.sessionStorage.setItem("userinfo", JSON.stringify(userinfo));
            this.$router.push({name:'account-m'});
            this.resultForm()
            // if(this.returnUrl){
            //     this.gotoTempId(data);
            // }else{
            //     this.$router.push({name:'account-m'});
            // }
        },
        resultForm(){
            this.form.account =''
            this.form.email =''
            this.form.verifyCode =''
            this.form.password =''
            this.form.checkPassword =''
            this.form.inviteCode =''
            this.isInviteCode =false
        },
        gotoTempId(data){

            let params = {
                returnUrl:this.returnUrl
            }
            axiosGet(this.url.tempId, params).then(res=>{
                if(res.success){
                    // window.open("https://"+res.result)
                    window.location.href = res.result;
                }else{
                    this.$message.error(res.message);
                }

                })
        },
    }
}
</script>
<style lang="less" scoped>
.m-page {
    background:url(~@/assets/img/login_bg.svg) no-repeat center center/2116px 2156px;
    .body {
        padding:50px 30px; min-height:800px; height:calc(100vh - 267px);
        .signup-box {
            padding:30px; border-radius:8px; background:#fff; box-shadow:0 0 8px rgba(0,0,0,.08);
            .hd {
                padding:0 0 30px;
                .title {
                    font-size:32px; font-weight:800;
                }
                .description {
                    font-size:16px; color:#999; font-weight:300;
                }
            }
            .bd {
                
                ::v-deep .el-tabs {
                    .el-tabs__header {
                        .el-tabs__item {
                            font-size:16px; text-transform:uppercase; //font-family: 'bebas_neueregular';
                        }
                    }
                }
                .form-item {
                    margin-bottom:15px;
                    ::v-deep .el-form-item__label {
                        font-weight:600; color:#999; line-height:30px;
                    }
                    ::v-deep .el-checkbox {
                        .el-checkbox__label {
                            font-weight:normal; color:#999;
                        }
                    }
                    ::v-deep .el-input-group__append {
                        background:transparent;
                        .el-button {
                            border-radius:0 4px 4px 0; color:#fff;
                            /*&.is-disabled {
                                opacity: .6;
                            }*/
                        }
                    }
                    .help {
                        line-height:1.47; color:#999; padding:5px 0 0;
                        .mail {color:#4458FE;}
                        .link {
                            color:#4458FE; font-weight:700; cursor: pointer;
                            &:hover {
                                opacity: .8;
                            }
                        }
                    }
                    .btn-login {
                        display:block; width:100%;
                    }
                }
            }
            .ft {
                padding:2px 0 0; text-align:center;
                .p {
                    color:#666;
                    .link {
                        font-weight:600; color:#4458FE; cursor: pointer;
                        &:hover {
                            text-decoration: underline; opacity:.8;
                        }
                    }
                }
            }
        }
    }
}
</style>